<template>

  <v-dialog v-model="visible" max-width="600">

    <template v-slot:activator="{ on }">
      <v-text-field v-on="on" readonly outlined label="Oaspeți" :value="c_value" class="ma-1" hide-details prepend-inner-icon="mdi-human-handsup"/>
    </template>

    <v-card>

      <v-toolbar dark class="primary elevation-0">
        <v-toolbar-title class="headline">Oaspeți</v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">

        <v-card outlined v-for="(room, index) in rooms" :key="index" class="ma-2">

          <v-card-title class="title pr-2">
            Camera {{index + 1}}
            <v-spacer/>
            <v-btn v-if="index > 0" icon color="red" @click="removeRoom(index)">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row fill-height align="center" justify="center">
              <v-col cols="6" class="py-1">
                <v-icon class="mr-2">mdi-human-male-female</v-icon>
                Adulti
              </v-col>
              <v-col cols="6" class="pa-1 text-end">
                <v-btn icon color="primary pa-1" @click="decAdults(room)">
                  <v-icon>mdi-minus-circle-outline</v-icon>
                </v-btn>
                {{ room.adults.length }}
                <v-btn icon color="primary pa-1" @click="incAdults(room)">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row fill-height align="center" justify="center">
              <v-col cols="6" class="py-1">
                <v-icon class="mr-2">mdi-human-female-boy</v-icon>
                Copii
              </v-col>
              <v-col cols="6" class="text-end pa-1">
                <v-btn icon color="primary pa-1" @click="decChildren(room)">
                  <v-icon>mdi-minus-circle-outline</v-icon>
                </v-btn>
                {{ room.children.length }}
                <v-btn icon color="primary pa-1" @click="incChildren(room)">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4" class="py-1" v-for="(child, index) in room.children" :key="index">
                <v-select v-model="child.age" outlined dense hide-details :label="'Vârsta ' + (index + 1)" offset-x :items="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,16,17]"/>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>

      </v-card-text>

      <v-card-actions>
        <v-btn outlined color="primary" @click="addRoom()">Adaugă Cameră</v-btn>
        <v-spacer/>
        <v-btn color="primary" depressed @click="visible = false">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
  export default {

    props: {
      rooms: {
        type: Array,
        default: () => [
          {
            adults: [
              {age: 'a'}
            ],
            children: [
              {age: null}
            ],
          }
        ]
      }
    },

    data() {
      return {
        visible: false,
        quantity: this.rooms,
      }
    },

    computed: {

      c_rooms: function () {
        return this.rooms.length;
      },

      c_adults: function () {
        return this.rooms.reduce((acc, room) => acc + room.adults.length, 0);
      },


      c_children: function () {
        return this.rooms.reduce((acc, room) => acc + room.children.length, 0);
      },

      c_value: function () {
        let guests = (this.c_children < 1) ? (this.c_adults > 1) ? 'Adulți' : 'Adult' : 'Oaspeți';
        let rooms = (this.c_rooms > 1) ? 'Camere' : 'Cameră';
        return `${this.c_adults + this.c_children} ${guests}, ${this.c_rooms} ${rooms}`;
      }

    },

    methods: {

      addRoom() {
        this.rooms.push({adults: [{age: 'a'}],children: []});
        // this.$emit('update:rooms', this.rooms);
      },

      removeRoom(index) {
        this.$delete(this.rooms, index);
        // this.$emit('update:rooms', this.rooms);
      },

      incAdults(room) {
        if (room.adults.length >= 9) return;
        room.adults.push({age: 'a'});
      },

      decAdults(room) {
        if (room.adults.length <= 1) return;
        this.$delete(room.adults, room.adults.length - 1);
      },

      incChildren(room) {
        if (room.children.length >= 9) return;
        room.children.push({age: 17});
      },

      decChildren(room) {
        if (room.children.length <= 0) return;
        this.$delete(room.children, room.children.length - 1);
      }

    }
  }
</script>